export default __webpack_public_path__ + "static/subcast-cc138d52cb43ae7d3beeb56a662987cd.svg";